import { Link } from "react-router-dom";

const articles = [
  {
    id: "how-oopbuy-spreadsheet-works",
    title: "How OOPBuy Spreadsheet Actually Works",
    desc: "A step-by-step breakdown of the OOPBuy spreadsheet workflow, from data import to actionable insights.",
    imageUrl: "https://readdy.ai/api/search-image?query=Closeup%20of%20hands%20typing%20on%20laptop%20keyboard%20with%20spreadsheet%20visible%20on%20screen%2C%20warm%20coffee%20cup%20nearby%2C%20modern%20workspace%2C%20soft%20natural%20window%20light%2C%20productive%20morning%20vibe%2C%20clean%20minimalist%20desk%2C%20editorial%20tech%20lifestyle%20photography&width=600&height=400&seq=art-sec-01&orientation=landscape",
    date: "June 2026",
  },
  {
    id: "oopbuy-spreadsheet-beginner-guide",
    title: "OOPBuy Spreadsheet Beginner Guide",
    desc: "No technical skills needed — a complete introduction for first-time users getting started with OOPBuy spreadsheets.",
    imageUrl: "https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20notes%20next%20to%20laptop%20showing%20simple%20spreadsheet%2C%20pencil%20and%20highlighter%20nearby%2C%20bright%20airy%20workspace%2C%20learning%20concept%2C%20soft%20natural%20daylight%2C%20clean%20and%20simple%20composition%2C%20editorial%20education%20photography&width=600&height=400&seq=art-sec-02&orientation=landscape",
    date: "June 2026",
  },
  {
    id: "best-oopbuy-spreadsheet-tools",
    title: "Best OOPBuy Spreadsheet Tools Ranked 2026",
    desc: "Our comprehensive ranking of the top spreadsheet tools — which one is right for your e-commerce needs?",
    imageUrl: "https://readdy.ai/api/search-image?query=Trophy%20and%20medal%20on%20a%20minimalist%20shelf%20with%20spreadsheet%20charts%20printed%20on%20paper%20beside%20them%2C%20ranking%20concept%2C%20warm%20ambient%20lighting%2C%20clean%20modern%20office%2C%20editorial%20business%20photography%2C%20achievement%20theme&width=600&height=400&seq=art-sec-03&orientation=landscape",
    date: "June 2026",
  },
  {
    id: "top-oopbuy-spreadsheets-compared",
    title: "Top 10 OOPBuy Spreadsheets Compared",
    desc: "Side-by-side feature comparison of the most popular spreadsheet systems — find your perfect match.",
    imageUrl: "https://readdy.ai/api/search-image?query=Two%20tablets%20side%20by%20side%20on%20a%20wooden%20desk%20each%20displaying%20different%20spreadsheet%20layouts%2C%20comparison%20concept%2C%20bright%20natural%20light%2C%20clean%20minimalist%20setup%2C%20editorial%20tech%20photography%2C%20professional%20workspace&width=600&height=400&seq=art-sec-04&orientation=landscape",
    date: "June 2026",
  },
  {
    id: "free-vs-paid-oopbuy-spreadsheet",
    title: "Free vs Paid OOPBuy Spreadsheet",
    desc: "Which one wins? We break down the real differences between free and premium spreadsheet tools.",
    imageUrl: "https://readdy.ai/api/search-image?query=Balance%20scale%20with%20coins%20on%20one%20side%20and%20a%20USB%20drive%20on%20the%20other%20on%20a%20clean%20white%20desk%2C%20comparison%20concept%2C%20soft%20studio%20lighting%2C%20minimalist%20photography%2C%20editorial%20business%20concept%2C%20neutral%20background&width=600&height=400&seq=art-sec-05&orientation=landscape",
    date: "June 2026",
  },
  {
    id: "oopbuy-spreadsheet-dropshipping",
    title: "OOPBuy Spreadsheet for Dropshipping",
    desc: "How to leverage spreadsheet tools for faster product sourcing and better dropshipping margins.",
    imageUrl: "https://readdy.ai/api/search-image?query=Cardboard%20boxes%20and%20shipping%20labels%20on%20a%20warehouse%20table%20with%20laptop%20nearby%20showing%20inventory%20data%2C%20dropshipping%20concept%2C%20warm%20industrial%20lighting%2C%20busy%20fulfillment%20atmosphere%2C%20editorial%20business%20photography&width=600&height=400&seq=art-sec-06&orientation=landscape",
    date: "June 2026",
  },
  {
    id: "oopbuy-spreadsheet-ecommerce",
    title: "OOPBuy Spreadsheet for E-commerce Sellers",
    desc: "Full guide for online store owners — manage products, track inventory, and optimize pricing.",
    imageUrl: "https://readdy.ai/api/search-image?query=Online%20store%20dashboard%20on%20a%20large%20monitor%20screen%20with%20product%20listings%20visible%2C%20ecommerce%20management%20concept%2C%20modern%20home%20office%2C%20soft%20screen%20glow%2C%20evening%20ambiance%2C%20editorial%20digital%20business%20photography&width=600&height=400&seq=art-sec-07&orientation=landscape",
    date: "June 2026",
  },
  {
    id: "make-money-oopbuy-spreadsheet",
    title: "How to Make Money with OOPBuy Spreadsheets",
    desc: "Real strategies for turning spreadsheet data into profitable e-commerce decisions and revenue growth.",
    imageUrl: "https://readdy.ai/api/search-image?query=Glass%20jar%20filled%20with%20coins%20and%20dollar%20bills%20on%20a%20desk%20next%20to%20a%20laptop%20displaying%20profit%20charts%2C%20financial%20success%20concept%2C%20warm%20golden%20lighting%2C%20motivational%20business%20photography%2C%20clean%20composition&width=600&height=400&seq=art-sec-08&orientation=landscape",
    date: "June 2026",
  },
  {
    id: "oopbuy-spreadsheet-product-research",
    title: "OOPBuy Spreadsheet for Product Research",
    desc: "Pro strategies for using spreadsheet data to identify winning products and market trends.",
    imageUrl: "https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20printed%20product%20catalog%20pages%20on%20a%20wooden%20desk%2C%20market%20research%20concept%2C%20warm%20desk%20lamp%20lighting%2C%20analytical%20atmosphere%2C%20editorial%20business%20investigation%20photography%2C%20rich%20textures&width=600&height=400&seq=art-sec-09&orientation=landscape",
    date: "June 2026",
  },
];

export default function ArticlesSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <p className="text-xs font-semibold text-foreground-500 uppercase tracking-[0.2em] mb-3 font-label">
            SEO Guides &amp; Resources
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 font-heading">
            OOPBuy Spreadsheet Knowledge Base
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto leading-relaxed">
            In-depth guides, comparisons, and tutorials — everything you need to master OOPBuy spreadsheet systems for your e-commerce success.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group rounded-[20px] bg-background-100 overflow-hidden hover:bg-background-200/70 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="h-[200px] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <span className="text-[10px] font-semibold text-foreground-400 uppercase tracking-wider mb-2 font-label">
                  {article.date}
                </span>
                <h3 className="text-base font-bold text-foreground-950 font-heading group-hover:text-foreground-800 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-2 leading-relaxed flex-1">
                  {article.desc}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-xs font-semibold text-accent-600 group-hover:text-accent-700 transition-colors">
                  Read Article <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}